const DEV_URL = 'http://192.168.99.109:5000'
const LOCAL_URL = 'http://localhost:5000'
const PROD_URL = 'https://timemachine.yeyuqiudeng.com'
export default {
  DEV_URL,
  LOCAL_URL,
  PROD_URL
}



// WEBPACK FOOTER //
// ./src/common/index.js